/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({"data":{"categories":{"cardinal":["few","one","other","two"],"ordinal":["few","one","other","two"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const n = Math.abs(parseFloat(numStr));
    if (isOrdinal) {
        if ((n === 3 || n === 13))
            return "few";
        if ((n === 1 || n === 11))
            return "one";
        if ((n === 2 || n === 12))
            return "two";
    }
    else {
        if (((n >= 3 && n <= 10) || (n >= 13 && n <= 19)))
            return "few";
        if ((n === 1 || n === 11))
            return "one";
        if ((n === 2 || n === 12))
            return "two";
    }
    return "other";
}},"locale":"gd"})
} else {
  (globalThis.__FORMATJS_PLURALRULES_DATA__ = globalThis.__FORMATJS_PLURALRULES_DATA__ || []).push({"data":{"categories":{"cardinal":["few","one","other","two"],"ordinal":["few","one","other","two"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const n = Math.abs(parseFloat(numStr));
    if (isOrdinal) {
        if ((n === 3 || n === 13))
            return "few";
        if ((n === 1 || n === 11))
            return "one";
        if ((n === 2 || n === 12))
            return "two";
    }
    else {
        if (((n >= 3 && n <= 10) || (n >= 13 && n <= 19)))
            return "few";
        if ((n === 1 || n === 11))
            return "one";
        if ((n === 2 || n === 12))
            return "two";
    }
    return "other";
}},"locale":"gd"})
}
